 /*
 Auto-generated by: https:github.com/pmndrs/gltfjsx
 author: Molodik (https:sketchfab.com/Molodik)
 license: CC-BY-4.0 (http:creativecommons.org/licenses/by/4.0/)
 source: https:sketchfab.com/3d-models/cyberpunk-night-scene-98b48acc4bb549e0b9cd32317805b992
 title: Cyberpunk Night Scene
 */

 import React, { useRef } from 'react'
 import { useGLTF } from '@react-three/drei'

 export default function Building({ ...props }) {
   const group = useRef()
   const { nodes, materials } = useGLTF('/building.glb')
   return (
     <group ref={group} {...props} dispose={null}>
       <group rotation={[-Math.PI / 2, 0, 0]}>
         <group rotation={[Math.PI / 2, 0, 0]}>
           <group position={[0, 0.09, 0]}>
             <mesh geometry={nodes.Object_4.geometry} material={materials.Bricks} />
           </group>
           <group position={[-3, 1, 3]}>
             <mesh geometry={nodes.Object_6.geometry} material={materials['Light.windows']} />
             <mesh geometry={nodes.Object_7.geometry} material={materials['building.001']} />
             <mesh geometry={nodes.Object_8.geometry} material={materials['Material.001']} />
           </group>
           <group position={[-3, 1, -3]}>
             <mesh geometry={nodes.Object_10.geometry} material={materials['building.001']} />
             <mesh geometry={nodes.Object_11.geometry} material={materials.Material} />
             <mesh geometry={nodes.Object_12.geometry} material={materials.paper} />
             <mesh geometry={nodes.Object_13.geometry} material={materials['Light.Neon.Pink']} />
           </group>
           <group position={[3, 1, -3]}>
             <mesh geometry={nodes.Object_15.geometry} material={materials['building.001']} />
             <mesh geometry={nodes.Object_16.geometry} material={materials['Light.windows.002']} />
             <mesh geometry={nodes.Object_17.geometry} material={materials['Light.windows.001']} />
             <mesh geometry={nodes.Object_18.geometry} material={materials.plastic} />
             <mesh geometry={nodes.Object_19.geometry} material={materials.road} />
           </group>
           <group position={[0, -0.08, 3]}>
             <mesh geometry={nodes.Object_21.geometry} material={materials.road} />
           </group>
           <group position={[0, -0.03, 3]}>
             <mesh geometry={nodes.Object_23.geometry} material={materials.Stone} />
           </group>
           <group position={[-2.62, 0.2, -1.59]}>
             <mesh geometry={nodes.Object_25.geometry} material={materials['Metal.Black']} />
           </group>
           <group position={[-2.75, 0.2, -1.19]}>
             <mesh geometry={nodes.Object_27.geometry} material={materials['Metal.Black']} />
           </group>
           <group position={[-2.75, 0.2, -1.97]}>
             <mesh geometry={nodes.Object_29.geometry} material={materials['Metal.Black']} />
           </group>
           <group position={[-4, 1.29, -1.19]}>
             <mesh geometry={nodes.Object_31.geometry} material={materials['Metal.Black']} />
           </group>
           <group position={[-3.77, 1.08, -1.19]}>
             <mesh geometry={nodes.Object_33.geometry} material={materials['Metal.Black']} />
           </group>
           <group position={[-3.77, 1.08, -1.97]}>
             <mesh geometry={nodes.Object_35.geometry} material={materials['Metal.Black']} />
           </group>
           <group position={[2.41, 0.09, 3.43]} scale={0.1}>
             <group position={[-1.2, 41.54, -3.91]} rotation={[0.36, 0.3, -0.1]} scale={9.82}>
               <mesh geometry={nodes.Object_39.geometry} material={materials['Light.LED.001']} />
               <mesh geometry={nodes.Object_40.geometry} material={materials['Metal.polish']} />
             </group>
             <group position={[0, 42.15, 1.36]} scale={[1, 0.62, 1]}>
               <mesh geometry={nodes.Object_42.geometry} material={materials['Metal.Black']} />
             </group>
             <group scale={[0.47, 1, 1]}>
               <mesh geometry={nodes.Object_44.geometry} material={materials['Metal.Black']} />
             </group>
             <group position={[0, 42.15, -1.39]} scale={[1, 0.62, 1]}>
               <mesh geometry={nodes.Object_46.geometry} material={materials['Metal.Black']} />
             </group>
             <group position={[0, 54.23, 9.34]} scale={0.55}>
               <mesh geometry={nodes.Object_48.geometry} material={materials.CABLES} />
             </group>
             <group position={[0, 54.23, 9.34]} scale={0.55}>
               <mesh geometry={nodes.Object_50.geometry} material={materials.CABLES} />
             </group>
             <group position={[-0.13, 40.33, -0.52]} rotation={[1.85, -0.06, -0.29]} scale={[9.82, 19.8, 9.82]}>
               <mesh geometry={nodes.Object_52.geometry} material={materials['Metal.polish']} />
             </group>
             <group position={[0, 54.23, 9.34]} scale={0.55}>
               <mesh geometry={nodes.Object_54.geometry} material={materials.CABLES} />
             </group>
             <group position={[0, 54.23, 9.34]} scale={0.55}>
               <mesh geometry={nodes.Object_56.geometry} material={materials.CABLES} />
             </group>
             <mesh geometry={nodes.Object_37.geometry} material={materials['Metal.polish']} />
           </group>
           <mesh geometry={nodes.Object_62.geometry} material={materials['Metal.polish']} />
           <mesh geometry={nodes.Object_64.geometry} material={materials['Metal.polish']} />
           <mesh geometry={nodes.Object_58.geometry} material={materials.car_metal} />
           <mesh geometry={nodes.Object_59.geometry} material={materials.car_scratches} />
           <mesh geometry={nodes.Object_60.geometry} material={materials['Metal.polish']} />
           <group position={[-3.06, 4.94, 1.07]}>
             <mesh geometry={nodes.Object_66.geometry} material={materials.car_scratches} />
             <mesh geometry={nodes.Object_67.geometry} material={materials.car_metal} />
           </group>
           <group position={[-1.24, 0, 0]}>
             <mesh geometry={nodes.Object_73.geometry} material={materials['Metal.polish']} />
             <mesh geometry={nodes.Object_75.geometry} material={materials['Metal.polish']} />
             <mesh geometry={nodes.Object_69.geometry} material={materials.car_metal} />
             <mesh geometry={nodes.Object_70.geometry} material={materials.car_scratches} />
             <mesh geometry={nodes.Object_71.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[-2.71, 5.21, 1.07]}>
             <mesh geometry={nodes.Object_77.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[-2.17, 3.37, 3]}>
             <mesh geometry={nodes.Object_79.geometry} material={materials.Jalusie} />
           </group>
           <group position={[-2.17, 3.37, 1]}>
             <mesh geometry={nodes.Object_81.geometry} material={materials.Jalusie} />
           </group>
           <group position={[-3, 3.34, 3.86]} rotation={[0, -Math.PI / 2, 0]} scale={[1, 1, 1.31]}>
             <mesh geometry={nodes.Object_83.geometry} material={materials.Jalusie} />
           </group>
           <group position={[-2.2, 0.7, 2.73]} scale={2}>
             <mesh geometry={nodes.Object_85.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[-2.22, 0.9, 2.85]} scale={2.35}>
             <mesh geometry={nodes.Object_87.geometry} material={materials['Light.Neon.LBlue']} />
             <mesh geometry={nodes.Object_88.geometry} material={materials['Material.001']} />
           </group>
           <group position={[0.77, 4.44, -0.98]} rotation={[-0.07, -0.03, -1.31]}>
             <mesh geometry={nodes.Object_90.geometry} material={materials.material_0} />
           </group>
           <group position={[0.77, 4.69, -0.98]} rotation={[-0.06, -0.03, -1.69]}>
             <mesh geometry={nodes.Object_92.geometry} material={materials.material_0} />
           </group>
           <group position={[0.78, 4.95, -0.98]} rotation={[3.06, 0.02, 1.42]}>
             <mesh geometry={nodes.Object_94.geometry} material={materials.material_0} />
           </group>
           <group position={[0.76, 4.6, -0.95]} rotation={[3.14, -0.02, 2.72]}>
             <mesh geometry={nodes.Object_96.geometry} material={materials.material_0} />
           </group>
           <group position={[0.16, 5.23, -1.02]} rotation={[Math.PI / 2, 0, 0]} scale={[1, 0.94, 1]}>
             <mesh geometry={nodes.Object_98.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[0.16, 4.7, -0.62]}>
             <mesh geometry={nodes.Object_100.geometry} material={materials.Frame} />
             <mesh geometry={nodes.Object_101.geometry} material={materials.Back} />
           </group>
           <group position={[0.16, 4.28, -1.02]} rotation={[Math.PI / 2, 0, 0]} scale={[1, 0.94, 1]}>
             <mesh geometry={nodes.Object_103.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[0.16, 6.12, -0.37]} rotation={[Math.PI / 2, 0, -Math.PI / 2]} scale={2}>
             <mesh geometry={nodes.Object_105.geometry} material={materials['Light.Neon.Pink']} />
           </group>
           <group position={[0.78, 6.1, -1.59]} scale={0.92}>
             <mesh geometry={nodes.Object_107.geometry} material={materials.car_scratches} />
           </group>
           <group position={[0.33, 0.71, -2.21]} scale={[0.7, 2.09, 0.7]}>
             <mesh geometry={nodes.Object_109.geometry} material={materials.material_0} />
           </group>
           <group position={[-1.85, 4.62, 1.47]} rotation={[0, 0, -Math.PI / 2]}>
             <mesh geometry={nodes.Object_111.geometry} material={materials.Texture} />
             <mesh geometry={nodes.Object_112.geometry} material={materials['Material.005']} />
           </group>
           <group position={[2.9, 1.97, -1.38]} rotation={[0, 0, -Math.PI / 2]}>
             <mesh geometry={nodes.Object_114.geometry} material={materials['Metal.polish']} />
             <mesh geometry={nodes.Object_115.geometry} material={materials['Light.bulb']} />
           </group>
           <group position={[-2, 2.11, 3.53]} rotation={[Math.PI, 0, -Math.PI / 2]} scale={0.96}>
             <mesh geometry={nodes.Object_117.geometry} material={materials['Light.bulb']} />
           </group>
           <group position={[-2.13, 4.09, 4.01]} scale={[2.75, 2.75, 1.06]}>
             <mesh geometry={nodes.Object_119.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[-1.38, 5.12, 0.76]} rotation={[0, 0, Math.PI]}>
             <mesh geometry={nodes.Object_121.geometry} material={materials['Metal.polish']} />
             <mesh geometry={nodes.Object_122.geometry} material={materials['Metal.Black']} />
             <mesh geometry={nodes.Object_123.geometry} material={materials['Light.LED']} />
           </group>
           <group position={[-1.38, 5.12, 2.19]} rotation={[0, 0, Math.PI]}>
             <mesh geometry={nodes.Object_125.geometry} material={materials['Metal.polish']} />
             <mesh geometry={nodes.Object_126.geometry} material={materials['Metal.Black']} />
             <mesh geometry={nodes.Object_127.geometry} material={materials['Light.LED']} />
           </group>
           <group position={[0.36, 5.39, -0.99]} scale={[4.92, 4.92, 1.9]}>
             <mesh geometry={nodes.Object_129.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[-3.17, 2.92, -1.97]} scale={[4.92, 4.92, 1.9]}>
             <mesh geometry={nodes.Object_131.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[-2.79, 3.2, -2.3]} rotation={[0, Math.PI / 4, 0]}>
             <group position={[0, 0.61, 0]}>
               <mesh geometry={nodes.Object_134.geometry} material={materials.plastic} />
             </group>
             <group position={[0.08, 0.61, 0]}>
               <mesh geometry={nodes.Object_136.geometry} material={materials.material_0} />
             </group>
             <group position={[-0.08, 0.61, 0]}>
               <mesh geometry={nodes.Object_138.geometry} material={materials.material_0} />
             </group>
           </group>
           <group position={[-2.24, 4.45, 3.83]} rotation={[0, Math.PI / 2, 0]}>
             <group position={[0, 0.61, 0]}>
               <mesh geometry={nodes.Object_141.geometry} material={materials.plastic} />
             </group>
             <group position={[0.08, 0.61, 0]}>
               <mesh geometry={nodes.Object_143.geometry} material={materials.material_0} />
             </group>
             <group position={[-0.08, 0.61, 0]}>
               <mesh geometry={nodes.Object_145.geometry} material={materials.material_0} />
             </group>
           </group>
           <group position={[1.06, 1.97, -1.38]} rotation={[0, 0, -Math.PI / 2]}>
             <mesh geometry={nodes.Object_147.geometry} material={materials['Metal.polish']} />
             <mesh geometry={nodes.Object_148.geometry} material={materials['Light.bulb']} />
           </group>
           <group position={[0.05, 5.41, -1]} rotation={[Math.PI / 2, 0, 0]} scale={0.02}>
             <mesh geometry={nodes.Object_150.geometry} material={materials.material_0} />
           </group>
           <group position={[-0.29, 0.13, 1.82]}>
             <mesh geometry={nodes.Object_152.geometry} material={materials.car_rust} />
           </group>
           <group position={[-0.29, 0.14, 1.82]} scale={[0.82, 0.37, 0.82]}>
             <mesh geometry={nodes.Object_154.geometry} material={materials['car_scratches.001']} />
           </group>
           <group position={[-1.72, 0.09, 3.76]} scale={[0.58, 0.83, 0.58]}>
             <mesh geometry={nodes.Object_156.geometry} material={materials.Cola_metal} />
             <mesh geometry={nodes.Object_157.geometry} material={materials['Metal.Black']} />
             <mesh geometry={nodes.Object_158.geometry} material={materials['Light.Neon.LBlue']} />
           </group>
           <group position={[-1.17, 0.09, 3.32]}>
             <mesh geometry={nodes.Object_160.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[-1.17, 0.09, 2.15]}>
             <mesh geometry={nodes.Object_162.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[3.25, 0.09, -1.04]} rotation={[0, Math.PI / 2, 0]}>
             <mesh geometry={nodes.Object_164.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[2.08, 0.09, -1.04]} rotation={[0, Math.PI / 2, 0]}>
             <mesh geometry={nodes.Object_166.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[-2.09, 0.2, -1.51]} rotation={[-2.77, -0.83, 1.81]}>
             <mesh geometry={nodes.Object_168.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[3.08, 0.09, -1.79]}>
             <mesh geometry={nodes.Object_170.geometry} material={materials['car_scratches.001']} />
             <mesh geometry={nodes.Object_171.geometry} material={materials.Vending_window} />
             <mesh geometry={nodes.Object_172.geometry} material={materials.Vending_buttons} />
             <mesh geometry={nodes.Object_173.geometry} material={materials.bottom} />
           </group>
           <group position={[2.2, 0.09, -1.61]}>
             <mesh geometry={nodes.Object_175.geometry} material={materials['Material.002']} />
           </group>
           <group position={[0.45, 0.09, -1.72]} rotation={[0, 1.19, 0]} scale={[1, 1, 0.84]}>
             <mesh geometry={nodes.Object_177.geometry} material={materials['Material.002']} />
           </group>
           <group position={[-1.6, 0.09, 1.06]} rotation={[0, 1.49, 0]} scale={[0.55, 1, 0.84]}>
             <mesh geometry={nodes.Object_179.geometry} material={materials['Material.002']} />
           </group>
           <group position={[1.36, 0.09, -1.65]} rotation={[0, 1.49, 0]} scale={[0.55, 1, 0.84]}>
             <mesh geometry={nodes.Object_181.geometry} material={materials['Material.002']} />
           </group>
           <group position={[-1.91, 0.09, 2.63]}>
             <mesh geometry={nodes.Object_183.geometry} material={materials['Material.002']} />
           </group>
           <group position={[-2.55, 0.24, -1.94]} rotation={[2.86, 0.64, -2.79]} scale={[0.55, 1, 0.84]}>
             <mesh geometry={nodes.Object_185.geometry} material={materials['Material.002']} />
           </group>
           <group position={[3.01, 0.09, 3.37]} rotation={[0, 0.89, 0]}>
             <mesh geometry={nodes.Object_187.geometry} material={materials.paper} />
           </group>
           <group position={[3.57, 0.09, -1.73]}>
             <mesh geometry={nodes.Object_189.geometry} material={materials['Material.006']} />
             <mesh geometry={nodes.Object_190.geometry} material={materials.plastic} />
           </group>
           <group position={[2.43, 0.12, -1.67]} rotation={[1.47, -0.13, 1]}>
             <mesh geometry={nodes.Object_192.geometry} material={materials['Material.006']} />
             <mesh geometry={nodes.Object_193.geometry} material={materials.plastic} />
           </group>
           <group position={[3.44, 0.09, -1.49]} scale={0.44}>
             <mesh geometry={nodes.Object_195.geometry} material={materials.Cola_red} />
             <mesh geometry={nodes.Object_196.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[1.96, 0.09, -1.85]} scale={0.44}>
             <mesh geometry={nodes.Object_198.geometry} material={materials.Cola_red} />
             <mesh geometry={nodes.Object_199.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[3.21, 0.11, -1.37]} rotation={[-0.41, 0, -Math.PI / 2]} scale={0.44}>
             <mesh geometry={nodes.Object_201.geometry} material={materials.Cola_red} />
             <mesh geometry={nodes.Object_202.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[2.52, 0.11, -1.56]} rotation={[-0.8, 0.99, -0.86]} scale={0.44}>
             <mesh geometry={nodes.Object_204.geometry} material={materials.Cola_red} />
             <mesh geometry={nodes.Object_205.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[2.9, 0.11, -1.47]} rotation={[-0.44, 0.39, -1.39]} scale={0.44}>
             <mesh geometry={nodes.Object_207.geometry} material={materials.Cola_red} />
             <mesh geometry={nodes.Object_208.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[2.75, 0.12, -1.57]} rotation={[1.5, 0.14, -1.04]}>
             <mesh geometry={nodes.Object_210.geometry} material={materials['Material.006']} />
             <mesh geometry={nodes.Object_211.geometry} material={materials.plastic} />
           </group>
           <group position={[-0.55, 0.12, 0.02]} rotation={[-Math.PI, 0.76, -Math.PI]} scale={[0.55, 1, 0.84]}>
             <mesh geometry={nodes.Object_213.geometry} material={materials['Material.002']} />
           </group>
           <group position={[3.43, 0.14, -0.58]} rotation={[-Math.PI, 0.76, -Math.PI]} scale={[0.55, 1, 0.84]}>
             <mesh geometry={nodes.Object_215.geometry} material={materials['Material.002']} />
           </group>
           <group position={[-0.67, 0.14, 1.03]} scale={[1.09, 1, 1]}>
             <mesh geometry={nodes.Object_217.geometry} material={materials['Material.002']} />
           </group>
           <group position={[2.74, 0.11, -0.54]} rotation={[-Math.PI, 1.06, -Math.PI]}>
             <mesh geometry={nodes.Object_219.geometry} material={materials['Material.002']} />
           </group>
           <group position={[2.66, 0.14, 2.41]} rotation={[0, 0.9, 0]}>
             <mesh geometry={nodes.Object_221.geometry} material={materials['Material.002']} />
           </group>
           <group position={[1.02, 0.14, 2.82]} rotation={[-0.44, 0.39, -1.39]} scale={0.44}>
             <mesh geometry={nodes.Object_223.geometry} material={materials.Cola_red} />
             <mesh geometry={nodes.Object_224.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[-0.66, 0.13, 0.63]} rotation={[-1.69, 1.16, 0.13]} scale={0.44}>
             <mesh geometry={nodes.Object_226.geometry} material={materials.Cola_red} />
             <mesh geometry={nodes.Object_227.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[-0.69, 0.13, 2.05]} rotation={[-2.13, -1.08, 2.52]} scale={0.44}>
             <mesh geometry={nodes.Object_229.geometry} material={materials.Cola_red} />
             <mesh geometry={nodes.Object_230.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[0.87, 0.14, 2.88]} rotation={[-0.43, 0.41, -1.43]} scale={0.44}>
             <mesh geometry={nodes.Object_232.geometry} material={materials.Cola_red} />
             <mesh geometry={nodes.Object_233.geometry} material={materials.Cola_metal} />
           </group>
           <group position={[1.52, 0.14, 3.09]} scale={[1.09, 1, 0.63]}>
             <mesh geometry={nodes.Object_235.geometry} material={materials['Material.002']} />
           </group>
           <group position={[-0.68, 0.14, 1.87]} rotation={[0, 1.51, 0]} scale={[1.09, 1, 0.63]}>
             <mesh geometry={nodes.Object_237.geometry} material={materials['Material.002']} />
           </group>
           <group position={[-3, 0.97, 3]}>
             <mesh geometry={nodes.Object_239.geometry} material={materials['bottom.001']} />
           </group>
           <group position={[-1.94, 1.68, 1.78]} rotation={[Math.PI / 2, 0, -Math.PI / 2]}>
             <mesh geometry={nodes.Object_241.geometry} material={materials['Light.Neon.Vel']} />
             <mesh geometry={nodes.Object_242.geometry} material={materials['plastic.001']} />
           </group>
           <group position={[-2.21, 0.1, -2]} rotation={[0, -0.35, 0]} scale={0.64}>
             <mesh geometry={nodes.Object_244.geometry} material={materials.paper} />
           </group>
           {/* <group scale={14.97}>
             <mesh geometry={nodes.Object_246.geometry} material={materials.material_0} />
           </group> */}
           <group position={[0, 8.15, 0]} scale={10.23}>
             <mesh geometry={nodes.Object_248.geometry} material={materials.material} />
           </group>
           <group position={[0.78, 5.62, -1.81]} scale={0.88}>
             <mesh geometry={nodes.Object_250.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[-2.46, 4.56, 3.22]} rotation={[0, Math.PI / 2, 0]}>
             <mesh geometry={nodes.Object_252.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[-2.46, 4.56, 3.46]} rotation={[0, Math.PI / 2, 0]}>
             <mesh geometry={nodes.Object_254.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[-2.46, 4.56, 2.97]} rotation={[0, Math.PI / 2, 0]}>
             <mesh geometry={nodes.Object_256.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[0.3, 3.12, -1.07]}>
             <mesh geometry={nodes.Object_258.geometry} material={materials['Light.Neon.LBlue']} />
           </group>
           <mesh geometry={nodes.Object_260.geometry} material={materials.material_0} />
           <group position={[-2.79, 3.2, -2.3]} rotation={[0, Math.PI / 4, 0]}>
             <mesh geometry={nodes.Object_262.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[-2.24, 4.45, 3.83]} rotation={[0, Math.PI / 2, 0]}>
             <mesh geometry={nodes.Object_264.geometry} material={materials['Metal.polish']} />
           </group>
           <group position={[2.36, 5.72, -2.45]}>
             <mesh geometry={nodes.Object_266.geometry} material={materials.CABLES} />
           </group>
           <group position={[3.45, 0.25, -1.96]} rotation={[Math.PI / 2, 0, 0]}>
             <mesh geometry={nodes.Object_268.geometry} material={materials.material_0} />
           </group>
          
           <group position={[0.2, 4.7, -0.38]} rotation={[Math.PI / 2, 0, -Math.PI / 2]}>
             <mesh geometry={nodes.Object_272.geometry} material={materials['Light.Neon.LBlue']} />
           </group>
           <group position={[-1.79, 4.55, 1.47]} rotation={[Math.PI / 2, 0, -Math.PI / 2]}>
             <mesh geometry={nodes.Object_274.geometry} material={materials.Cola_red} />
           </group>
           <group position={[1.73, 0.69, 0.88]} rotation={[Math.PI, -1.08, Math.PI]} scale={0.65}>
             <group position={[0.66, -0.42, 1.19]}>
               <group position={[0.11, -0.22, 0]} rotation={[0, 0, -Math.PI / 2]}>
                 <mesh geometry={nodes.Object_297.geometry} material={materials.car_light_fire} />
               </group>
               <mesh geometry={nodes.Object_290.geometry} material={materials.car_main_color} />
               <mesh geometry={nodes.Object_291.geometry} material={materials.car_metal} />
               <mesh geometry={nodes.Object_292.geometry} material={materials.car_light_fire} />
               <mesh geometry={nodes.Object_293.geometry} material={materials.car_rust} />
               <mesh geometry={nodes.Object_294.geometry} material={materials.car_scratches} />
               <mesh geometry={nodes.Object_295.geometry} material={materials.car_burned} />
             </group>
             <group position={[-0.66, -0.42, 1.19]} rotation={[-Math.PI, 0, 0]} scale={[-1, 1, 1]}>
               <group position={[0.11, 0.22, 0]} rotation={[Math.PI, 0, -Math.PI / 2]}>
                 <mesh geometry={nodes.Object_306.geometry} material={materials.car_light_fire} />
               </group>
               <mesh geometry={nodes.Object_299.geometry} material={materials.car_main_color} />
               <mesh geometry={nodes.Object_300.geometry} material={materials.car_metal} />
               <mesh geometry={nodes.Object_301.geometry} material={materials.car_light_fire} />
               <mesh geometry={nodes.Object_302.geometry} material={materials.car_rust} />
               <mesh geometry={nodes.Object_303.geometry} material={materials.car_scratches} />
               <mesh geometry={nodes.Object_304.geometry} material={materials.car_burned} />
             </group>
             <group position={[0.66, -0.46, -1]}>
               <group position={[0.11, -0.22, 0]} rotation={[0, 0, -Math.PI / 2]}>
                 <mesh geometry={nodes.Object_315.geometry} material={materials.car_light_fire} />
               </group>
               <mesh geometry={nodes.Object_308.geometry} material={materials.car_main_color} />
               <mesh geometry={nodes.Object_309.geometry} material={materials.car_metal} />
               <mesh geometry={nodes.Object_310.geometry} material={materials.car_light_fire} />
               <mesh geometry={nodes.Object_311.geometry} material={materials.car_rust} />
               <mesh geometry={nodes.Object_312.geometry} material={materials.car_scratches} />
               <mesh geometry={nodes.Object_313.geometry} material={materials.car_burned} />
             </group>
             <group position={[-0.66, -0.46, -1]} rotation={[-Math.PI, 0, 0]} scale={[-1, 1, 1]}>
               <group position={[0.11, 0.22, 0]} rotation={[Math.PI, 0, -Math.PI / 2]}>
                 <mesh geometry={nodes.Object_324.geometry} material={materials.car_light_fire} />
               </group>
               <mesh geometry={nodes.Object_317.geometry} material={materials.car_main_color} />
               <mesh geometry={nodes.Object_318.geometry} material={materials.car_metal} />
               <mesh geometry={nodes.Object_319.geometry} material={materials.car_light_fire} />
               <mesh geometry={nodes.Object_320.geometry} material={materials.car_rust} />
               <mesh geometry={nodes.Object_321.geometry} material={materials.car_scratches} />
               <mesh geometry={nodes.Object_322.geometry} material={materials.car_burned} />
             </group>
             <mesh geometry={nodes.Object_276.geometry} material={materials.car_main_color} />
             <mesh geometry={nodes.Object_277.geometry} material={materials.car_secondary_color} />
             <mesh geometry={nodes.Object_278.geometry} material={materials.car_metal} />
             <mesh geometry={nodes.Object_279.geometry} material={materials.car_windows} />
             <mesh geometry={nodes.Object_280.geometry} material={materials.car_luggage_brown} />
             <mesh geometry={nodes.Object_281.geometry} material={materials.car_luggage_beige} />
             <mesh geometry={nodes.Object_282.geometry} material={materials.car_licerse_plates} />
             <mesh geometry={nodes.Object_283.geometry} material={materials.car_light_head} />
             <mesh geometry={nodes.Object_284.geometry} material={materials.car_light_rear} />
             <mesh geometry={nodes.Object_285.geometry} material={materials.car_light_indicators} />
             <mesh geometry={nodes.Object_286.geometry} material={materials.car_black} />
             <mesh geometry={nodes.Object_287.geometry} material={materials.car_rust} />
             <mesh geometry={nodes.Object_288.geometry} material={materials['car_scratches.001']} />
           </group>
           <group position={[-0.43, 0.18, 2.28]} rotation={[-Math.PI, 0.32, -Math.PI / 2]} scale={1.87}>
             <mesh geometry={nodes.Object_326.geometry} material={materials['44821229-ea52-4c80-8dd0-a35b28c58ef6_1']} />
           </group>
         </group>
       </group>
     </group>
   )
 }

 useGLTF.preload('/building.glb')
